import React, {useCallback, useState} from "react"
import styles from '../css/Text.module.css'
import inputStyles from '../css/Input.module.css'
import Box from "./Box";
import LoadingSpinner from "./LoadingSpinner";
import classNames from "classnames";

export interface Props {
    id: string,
    label?: string,
    hint?: string,
    errorMessage?: string,
    onChange?: (value: string) => void,
    value?: string,
    autoCapitalize?: string,
    autoCorrect?: string,
    autoComplete?: string,
    multilines?: boolean,
    multilineCols?: number,
    multilineRows?: number
    inputMode?: "email" | "text" | "none" | "tel" | "url" | "numeric" | "decimal" | "search",
    defaultValue?: string,
    placeholder?: string,
    inline?: boolean,
    readonly?: boolean,
    maxLength?: number,
    hasLoadingIndicator?: boolean,
    isLoading?: boolean,
    allowSpaces?: boolean
}

export default (props: Props) => {

    // Props

    const {
        id,
        multilines,
        multilineCols = 40,
        multilineRows = 3,
        autoCapitalize,
        autoComplete,
        inline,
        autoCorrect,
        readonly,
        onChange,
        defaultValue,
        inputMode,
        label,
        hint,
        errorMessage,
        placeholder,
        maxLength,
        hasLoadingIndicator = false,
        isLoading = false,
        allowSpaces = inputMode !== 'email'
    } = props;

    // State

    const [value, setValue] = useState('');

    // Callbacks

    const handleChange = useCallback(
        (e) => {
            let value = e.target.value;
            value = value.length && allowSpaces ? value.trimStart() : value.trim();
            setValue(value);
            onChange && onChange(value)
        },
        [allowSpaces, onChange],
    );

    const handleOnBlur = useCallback(
        (e) => {
            let value = e.target.value.trim();
            setValue(value);
            onChange && onChange(value)
        },
        [onChange],
    );

    const v = props.value === undefined ? value : props.value;

    if (inline) {
        return <input
            readOnly={readonly}
            type={"text"}
            id={id}
            style={{width: '50%'}}
            inputMode={inputMode}
            autoCapitalize={autoCapitalize}
            autoCorrect={autoCorrect}
            autoComplete={autoComplete}
            defaultValue={defaultValue}
            // fix safari auto complete
            name={autoComplete === 'off' ? 'notASearchField' : undefined}
            maxLength={maxLength}
            onBlur={handleOnBlur}
            value={v}
            placeholder={placeholder}
            onChange={handleChange}
        />
    }

    return (
        <>
            {label ? <label htmlFor={id} className={styles.label}>{label}</label> : null}
            <Box fullWidth className={classNames({[inputStyles.containsLoadingIndicator]: hasLoadingIndicator})}>
                {
                    multilines ?
                        <textarea
                            id={id}
                            inputMode={inputMode}
                            readOnly={readonly}
                            autoCapitalize={autoCapitalize}
                            autoCorrect={autoCorrect}
                            autoComplete={autoComplete}
                            // fix safari auto complete
                            name={autoComplete === 'off' ? 'notASearchField' : undefined}
                            maxLength={maxLength}
                            defaultValue={defaultValue}
                            onBlur={handleOnBlur}
                            value={v}
                            placeholder={placeholder}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13 && !e.shiftKey) {
                                    e.preventDefault();
                                    return false;
                                }
                                return true
                            }}
                            cols={multilineCols}
                            rows={multilineRows}/>
                        :
                        <input
                            readOnly={readonly}
                            type={"text"}
                            id={id}
                            inputMode={inputMode}
                            autoCapitalize={autoCapitalize}
                            autoCorrect={autoCorrect}
                            autoComplete={autoComplete}
                            defaultValue={defaultValue}
                            // fix safari auto complete
                            name={autoComplete === 'off' ? 'notASearchField' : undefined}
                            maxLength={maxLength}
                            onBlur={handleOnBlur}
                            value={v}
                            placeholder={placeholder}
                            onChange={handleChange}
                        />
                }
                {
                    hasLoadingIndicator && isLoading &&
                    <div className={inputStyles.loadingIndicator}>
                        <LoadingSpinner/>
                    </div>
                }
            </Box>
            {hint ? <label htmlFor={id} className={styles.hint}>{hint}</label> : null}
            {errorMessage ? <label htmlFor={id} className={styles.error}>{errorMessage}</label> : null}

        </>
    )
}
